import layout from '../layout'
export default function makeGoalRoutes({
  contentType,
  components: { GoalListingContainer }
}) {

  return [
    {
      path: '/',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: `/${contentType.name}/list/`,
          component: GoalListingContainer,
          props: {
            contentType,
          }
        },
      ]
    },
  ];
}
